// extracted by mini-css-extract-plugin
export default {"label-wrapper":"TextArea_label-wrapper__vYHnJ","length-notice":"TextArea_length-notice__7ju7d"};